import React from "react";
import AbstractPage from "./AbstractPage";

class VehiclePreStart extends AbstractPage {
  constructor(props) {
    super(props)

    this.title = "Vehicle Pre-Start";
  }

  render() {
    return ""
  }
}

export default VehiclePreStart;



// WEBPACK FOOTER //
// ./src/views/VehiclePreStart.js